module.exports = __webpack_public_path__ + "img/new-workflow-source.cc9613fb.png";